import LTR from "@brand-icons/ploom/profile-default/profile-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ProfileDefaultIcon = iconFactory("ProfileDefaultIcon", LTR);
